<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-provincias
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-store-alt mr-2'></i>provincias</h4>"
          v-else
        ></table-provincias>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableProvincias from "./TableProvincias";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "facebookPages",
  components: {
    TableProvincias,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "code", label: "Alcance potencial", sortable: true },
        { key: "country_id", label: "Pais", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getProvincias();
  },
  methods: {
    getProvincias() {
      var provincias = store.getters.getProvincias;
      if (provincias.length == 0) {
        this.isLoading = true;
        store.dispatch("getProvincias").then(() => {
          provincias = store.getters.getProvincias;
          shuffleArray([provincias]);
          this.isLoading = false;
          this.items = provincias;
          this.itemsArray = provincias;
        });
      } else {
        shuffleArray([provincias]);
        this.items = provincias;
        this.itemsArray = provincias;
      }
    }
  }
};
</script>
